import { useEffect, useRef } from "react";

export default function Reveal({ children, className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const show = () => el.classList.add("reveal-in");
    const media = window.matchMedia?.("(prefers-reduced-motion: reduce)");

    if (media?.matches || typeof IntersectionObserver === "undefined") {
      show();
      return undefined;
    }

    const fallback = window.setTimeout(show, 1400);
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          show();
          window.clearTimeout(fallback);
          observer.disconnect();
        }
      },
      { threshold: 0.16 }
    );

    observer.observe(el);

    return () => {
      window.clearTimeout(fallback);
      observer.disconnect();
    };
  }, []);

  return (
    <div ref={ref} className={className}>
      {children}
    </div>
  );
}
